module.exports = __webpack_public_path__ + "img/background059.5bd78d33.jpg";